import { useSearchParams } from 'react-router';
import { EPG_TIMELINE_DAYS_BEFORE, EPG_TIMELINE_DAYS_AFTER } from '@jwp/ott-common/src/constants';
import type { EpgView } from '@jwp/ott-common/types/epg';

const VALID_DAY_OFFSET_MIN = EPG_TIMELINE_DAYS_BEFORE * -1; // Make negative
const VALID_DAY_OFFSET_MAX = EPG_TIMELINE_DAYS_AFTER;

export default function usePlaylistLiveChannelsParams() {
  const [searchParams] = useSearchParams();
  const channelId = searchParams.get('channel') ?? undefined;
  const programId = searchParams.get('program') ?? undefined;
  const play = searchParams.get('play') === '1';
  const liveStartDateTime = searchParams.get('start');
  const liveEndDateTime = searchParams.get('end');
  const liveFromBeginning = searchParams.get('beginning') === '1';

  const viewParam = searchParams.get('view');
  const dayOffsetParam = searchParams.get('offset');
  const isValidView = viewParam === 'guide' || viewParam === 'live';
  const isValidDayOffset = !isNaN(Number(dayOffsetParam)) && Number(dayOffsetParam) >= VALID_DAY_OFFSET_MIN && Number(dayOffsetParam) <= VALID_DAY_OFFSET_MAX;
  const view = isValidView ? (viewParam as EpgView) : 'guide';
  const dayOffset = isValidDayOffset ? Number(dayOffsetParam) : 0;

  return {
    channelId,
    programId,
    play,
    view,
    dayOffset,
    liveStartDateTime,
    liveEndDateTime,
    liveFromBeginning,
  };
}
